/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Rigid move or free scale</h4>

<p>Rigidily move or scale selected objects.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('556486918')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>M</b>: Show or hide manipulator</li>
    <li class='shortcuts__item'><b>Shift-move</b>: Move tool without affecting object</li>
    <li class='shortcuts__item'><b>Shift-scale</b>: Proportional scale</li>
    <li class='shortcuts__item'><b>G, L</b>: Switch to global or local positioning</li>
    <li class='shortcuts__item'><b>L</b>: Align manipulator with tangent</li>
</ul>`;

export default function MoveTooltip() {
    return h('div', { innerHTML: body });
}
